import { Box, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Announcements from "../common/Announcements";
import { selectedMenu, setAutocompleteVisibility, setHeaderText, } from "../../redux/actions/actions";

export default function AnnouncementsWrapper() {
    const dispatch = useDispatch()
    const slider = useSelector(state => state.sliderState.sliderOpen)

    useEffect(() => {
        dispatch(setHeaderText('Announcements'))
        dispatch(selectedMenu(4))
    }, [dispatch])
    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
            onClick={(e) => {
                e.stopPropagation()
                dispatch(setAutocompleteVisibility(false))
            }}
        >
            <Box
                width={['95%', '95%', '95%', '80%']}
                justifyContent='space-between'
                alignItems='center'
                d='flex'
                mb='2rem'
            >
                <Text
                    fontSize={['20px', '25px', '30px', '40px']}
                    d={['none', 'none', 'none', 'none', 'flex']}
                    fontWeight='900'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    pt='2rem'
                >
                    Announcements
                </Text>
            </Box>
            <Announcements dashboard={false} />
        </Box>
    )
}